import styled from "styled-components"

const Title = styled.h1`
  color: ${props => props.theme.colors.black};
  font-size: 1.8em;
  font-weight: 600;
`

export default Title
